<template>
  <div id="report-content">
    <div v-if="currentReport" class="single">
      <Report @updateReports="load" :reportsResume="reports"></Report>
    </div>
    <div v-else>
      <div class="meta">
        <div class="buttons">
          <v-btn class="button" outline @click="add" color="success"
            >{{ $t("partner.views.report.add") }}</v-btn
          >
        </div>
      </div>
      <v-data-table
        :headers="headers"
        :items="reports"
        no-data-text="$t('partner.views.report.no_results')"
        :no-results-text="message_not_found"
        :rows-per-page-items="rows_per_page"
        :pagination.sync="pagination"
        hide-actions
        :rows-per-page-text="message_rows_per_page"
      >
        <template v-slot:items="props">
          <tr>
            <td style="margin-left: 20px;">
              {{ humanizeDate(props.item.date) }}
            </td>
            <td style="text-align:left">
              {{ props.item.count }}
            </td>

            <td>
              <v-icon @click="edit(props.item.date)">edit</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Report from "@/components/domain/partner/Report";

export default {
  name: "Reports",
  props: { page: String },
  components: { Report },
  data() {
    return {
      headers: [
        {
          text: i18n.t("partner.views.report.headers.year_month"),
          value: "sort_date",
          sortable: true,
          width: "50%"
        },
        {
          text: i18n.t("partner.views.report.headers.count"),
          value: "count",
          sortable: true,
          width: "calc(50% - 50px)"
        },
        {
          text: "",
          value: "",
          sortable: false,
          width: "50px"
        }
      ],
      id: -1,
      message_not_found: i18n.t("partner.views.report.message_not_found"),
      message_rows_per_page: i18n.t("partner.views.report.message_rows_per_page"),
      rows_per_page: [20, 50, { text: "Todos", value: -1 }],
      pagination: {
        rowsPerPage: -1,
        sortBy: "sort_date",
        descending: true
      },
      empty_report: { date: -1 }
    };
  },
  computed: {
    currentReport() {
      return this.$store.getters["reports/getCurrentReport"];
    },

    reports() {
      var reports = { ...this.$store.getters["reports/getReports"] };

      var result = [];
      for (var index_date in reports) {
        result.push({
          date: index_date,
          sort_date: moment(index_date.replace("/", "/01/")),
          count: Object.keys(reports[index_date]).length
        });
      }

      return result;
    }
  },
  methods: {
    humanizeDate(date) {
      return date
        ? moment(date.replace("/", "/01/")).format("MMMM - YYYY")
        : "";
    },
    add() {
      this.$store.commit("reports/setCurrentReport", this.empty_report);
      this.$router.push({ name: "reports_add" });
    },

    edit(date) {
      this.$store.commit("reports/setCurrentReportByDate", date);
      this.$router.push({ name: "reports_edit", params: { date: date } });
    },

    updateReports() {
      this.load();
    },

    load() {
      var self = this;
      this.$store.commit("setTitle", "Google MyBusiness");
      this.$store.commit("setMenuVisible", false);

      this.$store.dispatch("reports/loadReports").then(function() {
        switch (self.page) {
          case "add":
            self.add();
            break;
          case "edit":
            self.edit(self.$route.params.date);
            break;
        }
      });
    }
  },
  watch: {
    $route: "load"
  },
  created() {
    this.load();
  },
  beforeRouteLeave(to, from, next) {
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#report-content {
  .meta {
    margin-bottom: 25px;
    overflow: hidden;

    .buttons {
      .button {
        float: right;
      }
    }
  }
}
</style>
